module.exports = __webpack_public_path__ + "img/Love_death+robots_Image_2.8249a6ef.png";